import CryptoJS from 'crypto-js';

const secretEncryptKey = 'adminVp';

export function encryptData(data) {
    if (typeof data === 'number') {
        data = data.toString();
    }
    return CryptoJS.AES.encrypt(data, secretEncryptKey).toString();

}

export function decryptData(encryptedData) {
    return CryptoJS.AES.decrypt(encryptedData, secretEncryptKey).toString(CryptoJS.enc.Utf8);
}
